import { TeaserBetTypes } from "../../../types";
export const isTeaserBet = (betType) => {
    return betType in TeaserBetTypes || betType.includes("Teaser");
};
//# sourceMappingURL=isTeaserBet.js.map